import { TemplateFile } from "../types/templates";
import modernIranStatesTemplate from "./templates/modernIranStates.json";
import historicalEmpiresTemplate from "./templates/historicalEmpires.json";

// Get all template files
export const getAllTemplateFiles = (): TemplateFile[] => {
  const templates: TemplateFile[] = [
    modernIranStatesTemplate as TemplateFile,
    historicalEmpiresTemplate as TemplateFile,
  ];

  return templates;
};

// Get a specific template file by ID
export const getTemplateFile = (id: string): TemplateFile | undefined => {
  const templates = getAllTemplateFiles();
  return templates.find((template) => template.id === id);
};

// Get template files by tag
export const getTemplateFilesByTag = (tag: string): TemplateFile[] => {
  const templates = getAllTemplateFiles();
  return templates.filter((template) =>
    template.tags?.some((t) => t.toLowerCase().includes(tag.toLowerCase()))
  );
};

// Get template collection with metadata
export const getTemplateCollection = () => {
  const files = getAllTemplateFiles();
  const totalStates = files.reduce((sum, file) => sum + file.states.length, 0);

  return {
    files,
    metadata: {
      totalFiles: files.length,
      totalStates,
      lastUpdated: new Date().toISOString(),
    },
  };
};

// Legacy function for backward compatibility
export const createTemplateFiles = (): TemplateFile[] => {
  return getAllTemplateFiles();
};
